export default value =>
  ((!value && value !== 0) || !String(value).trim()) &&
  "This field is required.";
